import Vue from 'vue'
import Vuex from 'vuex'
import VueCookie from 'vue-cookie'

Vue.use(Vuex)

const state = {
    userInfo: {
        detail: []
    },
    serviceType: VueCookie.get('serviceType') || 'house',
    merchantConfig: {},
    menuData: [],
    monitorData: {
        propertyLocationList: [],
        eventList: []
    }
}

const getters = {
    userId: (state) => {
        return state.userInfo.u__userId || ''
    },
    userRoleType: (state) => {
        return state.userInfo.detail[0].r__roleType || ''
    }
}

const mutations = {
    setUserInfo: (state, userInfo) => {
        state.userInfo = userInfo
    },
    setServiceType: (state, serviceType) => {
        state.serviceType = serviceType

        VueCookie.set('serviceType', serviceType)
    },
    setMenuData: (state, menuData) => {
        state.menuData = menuData
    },
    /**
     * 大屏所有小区数据
     * @param state
     * @param propertyLocationList
     */
    setPropertyLocationList: (state, propertyLocationList=[]) => {
        state.monitorData.propertyLocationList = propertyLocationList
    },
    /**
     * 大屏事件
     * @param state
     * @param eventList
     */
    setMonitorEventData: (state, eventList=[]) => {
        state.monitorData.eventList = eventList
    }
}

export default new Vuex.Store({
    state,
    getters,
    mutations
})



// WEBPACK FOOTER //
// ./src/vuex/store/index.js